module.exports = __webpack_public_path__ + "media/site_templates/www.excavate.company/images/testimonials-ff96f865d61a5a5c63f11e6cdb3bb331.jpg";